var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivePlay = function SvgLivePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 236 236"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 9.24,
    d: "M219 118c0 55.78-45.22 101-101 101S17 173.78 17 118 62.22 17 118 17s101 45.22 101 101Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M98.01 73.81v88.38l61.02-43.62z"
  }))));
};
export default SvgLivePlay;